export function createPhotoUrlWithSize(url: string, size: string) {
  return url.replace('{size}', size)
}
